const memoryStorage = new Map<string, string>();

function canUseLocalStorage(): boolean {
    try {
        const key = "__pitango_storage_test__";
        window.localStorage.setItem(key, "1");
        window.localStorage.removeItem(key);
        return true;
    } catch {
        return false;
    }
}

const hasLocalStorage = typeof window !== "undefined" && canUseLocalStorage();

/**
 * localStorage-compatible access for browsers, SSR, and sandboxed previews.
 * The in-memory fallback is intentionally session-only and never throws.
 */
export const safeStorage = {
    getItem(key: string): string | null {
        if (hasLocalStorage) {
            try { return window.localStorage.getItem(key); }
            catch { /* fall through */ }
        }
        return memoryStorage.get(key) ?? null;
    },

    setItem(key: string, value: string): void {
        if (hasLocalStorage) {
            try {
                window.localStorage.setItem(key, value);
                return;
            } catch { /* fall through */ }
        }
        memoryStorage.set(key, value);
    },

    removeItem(key: string): void {
        if (hasLocalStorage) {
            try {
                window.localStorage.removeItem(key);
                return;
            } catch { /* fall through */ }
        }
        memoryStorage.delete(key);
    }
};
